import { render, staticRenderFns } from "./EpaTable.vue?vue&type=template&id=a143f0ec"
import script from "./EpaTable.vue?vue&type=script&lang=js"
export * from "./EpaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports